import type { CheckboxButtonGroupOption } from '@capsule/consumer-design-system';
import { CheckboxButtonGroupVariant } from '@capsule/consumer-design-system';

import { Form } from 'formik';
import type { FormikProps } from 'formik';

import { FormikCheckboxButtonGroup } from '../../Form/FormikCheckboxButtonGroup/FormikCheckboxButtonGroup';

import { StyledForm } from './styles';

interface MedicationSelectorProps {
  formik: FormikProps<Record<string, any>>;
  accessibilityLabel?: string;
  formId: string;
  medicationsFormOptions: Pick<CheckboxButtonGroupOption, 'label' | 'value'>[];
}

export const MedicationsCheckBoxPicker = (props: MedicationSelectorProps) => {
  const { formId, medicationsFormOptions, accessibilityLabel } = props;
  return (
    <StyledForm id={formId} as={Form}>
      <FormikCheckboxButtonGroup
        label={{
          content: accessibilityLabel ? accessibilityLabel : 'Select all that apply',
          isHidden: true,
        }}
        options={medicationsFormOptions}
        variant={CheckboxButtonGroupVariant.SingleColumnCard}
      />
    </StyledForm>
  );
};
